module.exports = __webpack_public_path__ + "static/img/footer_bg.cd3476b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer_bg.png
// module id = ZkCN
// module chunks = 44